export default `
<style>
.payment-methods {
  margin-right: 60px;
  margin-left: 30px;
}

.payment-methods-title {
  font-size: 16px;
  margin-bottom: 16px;
  font-weight: 900;
  text-transform: uppercase;
}

.payment-methods-list {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  max-width: 190px;
  padding: 0;
  margin: 0;
  list-style-type: none;
  font-size: 0;
  gap: 4px;

}

.payment-methods-list img {
  opacity: .8;
  transition: opacity .4s;
}

.payment-methods-list img:hover {
  opacity: 1;
}

.exchange-rate {
  color: var(--footer_txt_1);
  font-size: var(--b-font-size-m);
  padding-top: var(--b-spacing-m);
  opacity: 0.5;
}

@media (max-width: 1023px) {
   .payment-methods {
     margin-top: 20px;
     margin-left: 16px;
     width: 100vw;
   }
 
 .payment-methods-list {
   max-width: 100%;
 }
}
</style> 
<div class="payment-methods">
    <div class="payment-methods-title">Načini plaćanja</div>
    <ul class="payment-methods-list">
        <li>
            <a href="/nacini-placanja">
                <img src="https://www.favbet.hr/static/media/payment/logos/maestro.svg" alt="Maestro">
            </a>
        </li>
        <li>
            <a href="/nacini-placanja">
                <img src="https://www.favbet.hr/static/media/payment/logos/mastercard.svg" alt="Mastercard">
            </a>
        </li>
        <li>
            <a href="/nacini-placanja">
                <img src="https://www.favbet.hr/static/media/payment/logos/visa.svg" alt="Visa">
            </a>
        </li>
        <li>
          <a href="/nacini-placanja">
            <img src="https://www.favbet.hr/static/media/payment/logos/aircash.svg" alt="Aircash">
          </a>
        </li>
        <li>
            <a href="/nacini-placanja">
                <img src="https://www.favbet.hr/static/media/payment/logos/abon.svg" alt="Abon">
            </a>
        </li>
        <li>
            <a href="/nacini-placanja">
                <img src="https://www.favbet.hr/static/media/payment/logos/corvuspay.svg" alt="Corvus Pay">
            </a>
        </li>
        <li>
            <a href="/nacini-placanja">
                <img src="https://www.favbet.hr/static/media/payment/logos/poslovnica.svg" alt="Poslovnica">
            </a>
        </li>
    </ul>
    <div class="exchange-rate">1 EUR = 7.53450 HRK</div>
</div>`;
